module.exports = __webpack_public_path__ + "img/icon-dollar-sign.967ed4e0.svg";